<template>
  <information-page :title="$t('views.misc.voting_instructions.title')">
    <template v-slot:navbar>
      <navbar class="px-8" />
    </template>
    <template v-slot:content>
      <div class="font-bold">
        {{ $t("views.misc.voting_instructions.section_options_title") }}
      </div>
      <p>
        <span class="font-bold">
          {{ $t("views.misc.voting_instructions.section_options_text_1") }}
        </span>
      </p>
      <p>
        {{ $t("views.misc.voting_instructions.section_options_text_2") }}
      </p>
      <hr />
      <div class="font-bold">
        {{ $t("views.misc.voting_instructions.section_decide_title") }}
      </div>
      <p>
        <span class="font-bold">
          {{ $t("views.misc.voting_instructions.section_decide_text_1") }}
        </span>
      </p>
      <p>
        {{ $t("views.misc.voting_instructions.section_decide_text_2") }}
      </p>
      <p>
        {{ $t("views.misc.voting_instructions.section_decide_text_3") }}
      </p>
      <p>
        {{ $t("views.misc.voting_instructions.section_decide_text_4") }}
      </p>
      <hr />
      <div class="font-bold">
        {{ $t("views.misc.voting_instructions.section_ballot_title_1") }}
      </div>
      <p>
        {{ $t("views.misc.voting_instructions.section_ballot_text_1") }}
      </p>
      <p>
        <span class="font-bold">
          {{ $t("views.misc.voting_instructions.section_ballot_o1_title") }}
        </span>
      </p>
      <p>
        {{ $t("views.misc.voting_instructions.section_ballot_o1_text_1") }}
      </p>
      <p>
        <span class="font-bold">
          {{ $t("views.misc.voting_instructions.section_ballot_o2_title") }}
        </span>
      </p>
      <p>
        {{ $t("views.misc.voting_instructions.section_ballot_o2_text_1") }}
      </p>
      <p>
        <span class="font-bold">
          {{ $t("views.misc.voting_instructions.section_ballot_o3_title") }}
        </span>
      </p>
      <p>
        {{ $t("views.misc.voting_instructions.section_ballot_o3_text_1") }}
      </p>
      <hr />
      <div class="font-bold">
        {{ $t("views.misc.voting_instructions.section_submit_title") }}
      </div>
      <p>
        {{ $t("views.misc.voting_instructions.section_submit_text_1") }}
      </p>
      <hr />
      <div class="font-bold">
        {{ $t("views.misc.voting_instructions.section_more_info_title") }}
      </div>
      <a
        href="https://www.easyvote.ch/de/wahlen/kantonale-wahlen"
        target="_blank"
      >
        <button
          type="button"
          class="p-3 mt-1 mb-8 rounded-lg text-white bg-gradient-blue"
        >
          www.easyvote.ch
        </button></a
      >
    </template>
  </information-page>
</template>

<script>
import Navbar from "@/components/nav/NavBarInformation";
import InformationPage from "@/components/layouts/InformationPage.vue";

// import VideoFrame from "@/components/videos/VideoFrame";

export default {
  name: "VotingInstructions",
  components: {
    InformationPage,
    Navbar
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.dispatch("userPath/checkPath", from.name);
    });
  }
};
</script>
